import React, { useState } from 'react'
import ReactiveButton from 'reactive-button';
import { send } from 'emailjs-com'
// Notifications
import toast from 'react-hot-toast'
import Footer from '../components/Footer'

const Contact = () => {
  const [state, setState] = useState('idle');
  const [toSend, setToSend] = useState({
      from_name: '',
      subject: '',
      message: '',
      reply_to: '',
    })

    const onClickHandler = () => {
        setState('loading');
        setTimeout(() => {
            setState('success');
        }, 2000);
    }

    const onSubmit = (e) => {
      e.preventDefault();
      send(
        'service_yp6885i',
        'template_mq1jslo',
        toSend,
        'user_5bQagzobdEKupULSjq1Ym'
      )
        .then((response) => {
          toast.success("Message sent! Thanks!")
          setToSend({
              from_name: '',
              subject: '',
              message: '',
              reply_to: '',
            })
        })
        .catch((err) => {
          // Handle error silently or show error toast if needed
        })
    }

    const handleChange = (e) => {
      setToSend({ ...toSend, [e.target.name]: e.target.value })
    }

    return(
        <div className="min-h-screen bg-background-dark text-slate-100 font-display">
            {/* Hero Section */}
            <section className="relative py-20 lg:py-32 overflow-hidden">
                <div className="absolute inset-0 bg-accent/5"></div>
                <div className="container mx-auto px-6 relative z-10">
                    <div className="text-center mb-16">
                        <div className="inline-flex items-center space-x-2 bg-accent/10 border border-accent/20 text-accent px-6 py-3 rounded-full text-sm font-semibold mb-8">
                            <span className="w-2 h-2 bg-accent rounded-full"></span>
                            <span>Let's Connect</span>
                            <span className="w-2 h-2 bg-accent rounded-full"></span>
                        </div>
                        <h1 className="text-5xl lg:text-7xl font-bold text-slate-100 mb-6 leading-tight">
                            Contact
                        </h1>
                        <p className="text-xl lg:text-2xl text-slate-400 max-w-3xl mx-auto leading-relaxed">
                            Let's have a chat! What's on your mind?
                        </p>
                    </div>
                </div>
            </section>

            {/* Contact Form Section */}
            <section className="py-16 lg:py-24">
                <div className="container mx-auto px-6">
                    <div className="max-w-4xl mx-auto">
                        <div className="bg-slate-800/30 rounded-3xl p-8 lg:p-12 border border-accent/10">
                            <form onSubmit={onSubmit} className="space-y-8">
                                {/* Name and Email Row */}
                                <div className="grid md:grid-cols-2 gap-6">
                                    <div className="space-y-2">
                                        <label className="text-slate-100 font-semibold text-sm uppercase tracking-wider">
                                            Your Name
                                        </label>
                                        <input
                                            required
                                            name='from_name'
                                            value={toSend.from_name}
                                            onChange={handleChange}
                                            type="text"
                                            className="w-full px-6 py-4 bg-slate-800/50 border border-slate-600 rounded-xl text-slate-100 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent transition-all duration-300"
                                            placeholder="Enter your name"
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-slate-100 font-semibold text-sm uppercase tracking-wider">
                                            Your Email
                                        </label>
                                        <input
                                            required
                                            name='reply_to'
                                            value={toSend.reply_to}
                                            onChange={handleChange}
                                            type="email"
                                            className="w-full px-6 py-4 bg-slate-800/50 border border-slate-600 rounded-xl text-slate-100 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent transition-all duration-300"
                                            placeholder="Enter your email"
                                        />
                                    </div>
                                </div>

                                {/* Subject */}
                                <div className="space-y-2">
                                    <label className="text-slate-100 font-semibold text-sm uppercase tracking-wider">
                                        Subject
                                    </label>
                                    <input
                                        required
                                        name='subject'
                                        value={toSend.subject}
                                        onChange={handleChange}
                                        type="text"
                                        className="w-full px-6 py-4 bg-slate-800/50 border border-slate-600 rounded-xl text-slate-100 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent transition-all duration-300"
                                        placeholder="What's this about?"
                                    />
                                </div>

                                {/* Message */}
                                <div className="space-y-2">
                                    <label className="text-slate-100 font-semibold text-sm uppercase tracking-wider">
                                        Message
                                    </label>
                                    <textarea
                                        required
                                        name='message'
                                        value={toSend.message}
                                        onChange={handleChange}
                                        className="w-full px-6 py-4 bg-slate-800/50 border border-slate-600 rounded-xl text-slate-100 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent transition-all duration-300 resize-none"
                                        placeholder="Tell me more about your project or inquiry..."
                                        rows="6"
                                    />
                                </div>

                                {/* Submit Button */}
                                <div className="text-center pt-4">
                                    <ReactiveButton
                                        type="submit"
                                        buttonState={state}
                                        onClick={onClickHandler}
                                        color={'primary'}
                                        idleText={'Send Message'}
                                        loadingText={'Sending...'}
                                        successText={'Message Sent!'}
                                        errorText={'Error'}
                                        className={'bg-accent hover:bg-accent/90 text-background-dark px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl border-0'}
                                        style={{ borderRadius: '12px' }}
                                        outline={false}
                                        shadow={false}
                                        rounded={false}
                                        size={'normal'}
                                        block={false}
                                        messageDuration={2000}
                                        disabled={false}
                                        buttonRef={null}
                                        width="300px"
                                        height={null}
                                        animation={true}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Information */}
            <section className="py-16 lg:py-24">
                <div className="container mx-auto px-6">
                    <div className="max-w-6xl mx-auto">
                        <div className="grid md:grid-cols-3 gap-8">
                            {/* Email */}
                            <div className="text-center group">
                                <div className="bg-accent/5 rounded-2xl p-8 border border-accent/10 hover:border-accent/20 transition-all duration-300">
                                    <div className="w-16 h-16 bg-accent rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                                        <svg className="w-8 h-8 text-background-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                        </svg>
                                    </div>
                                    <h3 className="text-xl font-semibold text-slate-100 mb-2">Email</h3>
                                    <p className="text-slate-400">Get in touch via email</p>
                                    <a href="mailto:info@andycary.com" className="text-accent hover:text-accent/90 transition-colors duration-300">
                                        Email
                                    </a>
                                </div>
                            </div>

                            {/* LinkedIn */}
                            <div className="text-center group">
                                <div className="bg-accent/5 rounded-2xl p-8 border border-accent/10 hover:border-accent/20 transition-all duration-300">
                                    <div className="w-16 h-16 bg-accent rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                                        <svg className="w-8 h-8 text-background-dark" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                                        </svg>
                                    </div>
                                    <h3 className="text-xl font-semibold text-slate-100 mb-2">LinkedIn</h3>
                                    <p className="text-slate-400">Connect professionally</p>
                                    <a href="https://www.linkedin.com/in/andrewdcary/" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-accent/90 transition-colors duration-300">
                                        /in/andrewdcary
                                    </a>
                                </div>
                            </div>

                            {/* GitHub */}
                            <div className="text-center group">
                                <div className="bg-accent/5 rounded-2xl p-8 border border-accent/10 hover:border-accent/20 transition-all duration-300">
                                    <div className="w-16 h-16 bg-accent rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                                        <svg className="w-8 h-8 text-background-dark" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                                        </svg>
                                    </div>
                                    <h3 className="text-xl font-semibold text-slate-100 mb-2">GitHub</h3>
                                    <p className="text-slate-400">View my code</p>
                                    <a href="https://github.com/acary" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-accent/90 transition-colors duration-300">
                                        github.com/acary
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Call to Action */}
            <section className="py-16 lg:py-24">
                <div className="container mx-auto px-6">
                    <div className="text-center">
                        <div className="bg-accent/5 rounded-3xl p-12 border border-accent/10">
                            <h3 className="text-3xl lg:text-4xl font-bold text-slate-100 mb-6">
                                Ready to start your next project?
                            </h3>
                            <p className="text-xl text-slate-400 mb-8 max-w-2xl mx-auto">
                                Whether you need software development, nutrition coaching, or just want to chat about technology, I'm here to help bring your ideas to life.
                            </p>
                            <div className="flex flex-col sm:flex-row gap-4 justify-center">
                                <a
                                    href="/portfolio"
                                    className="inline-flex items-center space-x-2 bg-accent text-background-dark hover:bg-accent/90 px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
                                >
                                    <span>View My Work</span>
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                    </svg>
                                </a>
                                <a
                                    href="/about"
                                    className="inline-flex items-center space-x-2 border border-accent/30 text-accent hover:bg-accent/5 px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 transform hover:scale-105"
                                >
                                    <span>Learn About Me</span>
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default Contact;
